const scriptLoads: { [url: string]: Promise<void> } = {};

export function loadExternalScript(url: string, id: string): Promise<void> {
  if (scriptLoads[url]) {
    return scriptLoads[url];
  }

  scriptLoads[url] = new Promise<void>((resolve, reject) => {
    const existing = document.getElementById(id) as HTMLScriptElement;
    if (existing) {
      if (existing.getAttribute('data-loaded') === 'true') {
        resolve();
        return;
      }
      existing.addEventListener('load', () => resolve());
      existing.addEventListener('error', () => reject(new Error(`Could not load ${url}`)));
      return;
    }

    const script = document.createElement('script');
    script.id = id;
    script.src = url;
    script.async = true;
    script.addEventListener('load', () => {
      script.setAttribute('data-loaded', 'true');
      resolve();
    });
    script.addEventListener('error', () => reject(new Error(`Could not load ${url}`)));
    document.head.appendChild(script);
  });

  return scriptLoads[url];
}
